var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-list" },
    [
      _c("div", { staticClass: "title" }, [_vm._v("用户列表")]),
      _c(
        "el-form",
        { staticClass: "search-form", attrs: { inline: true } },
        [
          _c(
            "el-col",
            { attrs: { span: 19 } },
            [
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: { placeholder: "输入姓名/账号", clearable: "" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.queryUserList("search")
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "append",
                        fn: function () {
                          return [
                            _c("el-button", {
                              attrs: { icon: "el-icon-search" },
                              on: {
                                click: function ($event) {
                                  return _vm.queryUserList("search")
                                },
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.searchName,
                      callback: function ($$v) {
                        _vm.searchName = $$v
                      },
                      expression: "searchName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 5 } },
            [
              _c(
                "el-button",
                {
                  staticClass: "button-container",
                  attrs: { type: "primary", size: "14" },
                  on: { click: _vm.handleAdd },
                },
                [_vm._v("新增用户")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableUserData,
            size: "medium",
            "header-cell-style": { background: "#F5F6F7" },
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "账号" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.username || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "姓名" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " + _vm._s(scope.row.name || "-") + "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm.rolesCode !== "PLATFORM_ADMIN"
            ? _c("el-table-column", {
                attrs: { label: "角色" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n        " +
                              _vm._s(scope.row.roleName || "-") +
                              "\n      "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3966082531
                ),
              })
            : _vm._e(),
          _vm.rolesCode === "PLATFORM_ADMIN" || _vm.rolesCode === "ROLE_ADMIN"
            ? _c("el-table-column", {
                attrs: { label: "组织" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n        " +
                              _vm._s(scope.row.tenantName || "-") +
                              "\n      "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  702227123
                ),
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: { label: "状态", width: "110" },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    _c(
                      "el-popover",
                      {
                        ref: "statusPopover",
                        attrs: {
                          placement: "bottom",
                          width: "127",
                          trigger: "click",
                          "popper-class": "custom-popover",
                        },
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "reference" }, slot: "reference" },
                          [
                            _c("span", { staticClass: "search-title" }, [
                              _vm._v("状态"),
                            ]),
                            _c("i", {
                              staticClass: "iconfont icon-biaogeshaixuan",
                            }),
                          ]
                        ),
                        _c(
                          "el-checkbox-group",
                          {
                            staticClass: "status-group",
                            model: {
                              value: _vm.selectValue,
                              callback: function ($$v) {
                                _vm.selectValue = $$v
                              },
                              expression: "selectValue",
                            },
                          },
                          _vm._l(_vm.selectOptions, function (item) {
                            return _c(
                              "el-checkbox",
                              {
                                key: item.value,
                                staticClass: "status-checkbox",
                                attrs: { value: item.value, label: item.value },
                              },
                              [_c("div", [_vm._v(_vm._s(item.label))])]
                            )
                          }),
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "status-btn-box" },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "btn",
                                attrs: { size: "mini", type: "primary" },
                                on: { click: _vm.filterStatus },
                              },
                              [_vm._v("确定")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", {
                      staticClass: "identifying",
                      class: { disable: scope.row.lockFlag === "9" },
                    }),
                    _c("span", [
                      _vm._v(
                        _vm._s(scope.row.lockFlag === "0" ? "正常" : "禁用")
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { fixed: "right", label: "操作", width: "250" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "operate" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "operate" },
                        on: {
                          click: function ($event) {
                            return _vm.handleStatus(scope.row)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.lockFlag === "0" ? "禁用" : "启用"
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          size: "operate",
                          disabled: scope.row.lockFlag === "0",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleDelete(scope.row.userId)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.currentPage,
          "page-size": _vm.pageSize,
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper",
          "page-sizes": [10, 20, 50],
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.status === "add" ? "新增用户" : "编辑用户",
            visible: _vm.dialogVisible,
            width: "628px",
            "before-close": _vm.handleClose,
            "custom-class": "user-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "define-form",
              attrs: {
                model: _vm.addFormData,
                rules: _vm.rules,
                "label-width": "80px",
                "label-position": "right",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: "账号", prop: "username" },
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function () {
                        return [
                          _c("span", [_vm._v("账号")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: { content: "支持邮箱", placement: "top" },
                            },
                            [_c("i", { staticClass: "iconfont icon-wenhao" })]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.status !== "add",
                      placeholder: "请输入邮箱",
                      maxlength: "32",
                      clearable: "",
                    },
                    model: {
                      value: _vm.addFormData.username,
                      callback: function ($$v) {
                        _vm.$set(_vm.addFormData, "username", $$v)
                      },
                      expression: "addFormData.username",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.rolesCode === "PLATFORM_ADMIN",
                      expression: "rolesCode === 'PLATFORM_ADMIN'",
                    },
                  ],
                  attrs: { label: "角色", prop: "roleCode" },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择角色", clearable: "" },
                      model: {
                        value: _vm.addFormData.roleCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.addFormData, "roleCode", $$v)
                        },
                        expression: "addFormData.roleCode",
                      },
                    },
                    _vm._l(_vm.roleData, function (item) {
                      return item.roleCode === "CUSTOM_ADMIN"
                        ? _c("el-option", {
                            key: item.roleCode,
                            attrs: {
                              label: item.roleName,
                              value: item.roleCode,
                            },
                          })
                        : _vm._e()
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.rolesCode !== "PLATFORM_ADMIN",
                      expression: "rolesCode !== 'PLATFORM_ADMIN'",
                    },
                  ],
                  attrs: { label: "角色", prop: "roleCode" },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择角色", clearable: "" },
                      model: {
                        value: _vm.addFormData.roleCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.addFormData, "roleCode", $$v)
                        },
                        expression: "addFormData.roleCode",
                      },
                    },
                    _vm._l(_vm.roleData, function (item) {
                      return _c("el-option", {
                        key: item.roleCode,
                        attrs: { label: item.roleName, value: item.roleCode },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.rolesCode === "PLATFORM_ADMIN",
                      expression: "rolesCode === 'PLATFORM_ADMIN'",
                    },
                  ],
                  attrs: { label: "组织", prop: "tenantId" },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择组织", clearable: "" },
                      model: {
                        value: _vm.addFormData.tenantId,
                        callback: function ($$v) {
                          _vm.$set(_vm.addFormData, "tenantId", $$v)
                        },
                        expression: "addFormData.tenantId",
                      },
                    },
                    _vm._l(_vm.tenantData, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "14" }, on: { click: _vm.handleClose } },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "14" },
                  on: { click: _vm.onsubmit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }